import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { media } from '../../config/settings/media'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
  width: 100%;
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  width: 100%;
`

export const UtmInputWrap = styled.div`
  width: 100%;
  max-width: ${({ $fullWidth }) => ($fullWidth ? 'none' : '10.5rem')};

  ${({ $textCentered }) =>
    $textCentered &&
    `
    input {
      text-align: center;
    }
  `}
`

export const FormLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const FormHint = styled.p`
  margin: 0;
  font-size: 0.6875rem;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const MethodBadge = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
  padding: 0.85rem 0.95rem;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => `${theme.colors.action.primary.bg}55`};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.14)'
      : 'rgba(62, 207, 142, 0.08)'};

  strong {
    font-size: 0.875rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.action.primary.bg};
  }

  span {
    font-size: 0.75rem;
    line-height: 1.45;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const LegacyToggle = styled(Link)`
  align-self: flex-start;
  margin-top: 0.15rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textMuted};
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`

export const WarningNote = styled.p`
  margin: 0 0 0.35rem;
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  border-left: 3px solid ${({ theme }) => theme.colors.action.warning?.bg || '#f0ad4e'};
  background: ${({ theme }) =>
    theme.name === 'dark'
      ? 'rgba(240, 173, 78, 0.12)'
      : 'rgba(240, 173, 78, 0.1)'};
  font-size: 0.75rem;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const MethodOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;

  ${media.sm`
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
  `}
`

export const MethodOption = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  width: 100%;
  min-height: 72px;
  height: 100%;
  padding: 0.85rem 0.95rem;
  border-radius: 10px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active
        ? `${theme.colors.action.primary.bg}88`
        : theme.colors.borderDefault};
  background: ${({ $active, theme }) => {
    if (!$active) return theme.colors.background
    return theme.name === 'dark'
      ? 'rgba(62, 207, 142, 0.16)'
      : 'rgba(62, 207, 142, 0.08)'
  }};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  strong {
    font-size: 0.875rem;
    font-weight: 600;
    color: ${({ $active, theme }) =>
      $active
        ? theme.colors.action.primary.bg
        : theme.colors.textPrimary};
  }

  span {
    font-size: 0.75rem;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.textMuted};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => `${theme.colors.action.primary.bg}55`};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const FieldError = styled.p`
  margin: ${({ $centered }) => ($centered ? '0.5rem 0 0' : '0')};
  font-size: 0.75rem;
  font-weight: 500;
  text-align: ${({ $centered }) => ($centered ? 'center' : 'start')};
  color: ${({ theme }) => theme.colors.action.danger.bg};
`
